import { getI18n } from 'react-i18next';

export const VALIDATION_PRODUCT_ID_ALREADY_USED = 'validation.product.productIdAlreadyInUse';
export const VALIDATION_PRODUCT_EMPTY_NAME = 'validation.product.emptyName';
export const VALIDATION_PRODUCT_IMMUTABLE_NAME = 'validation.product.immutableName';
export const VALIDATION_PRODUCT_EMPTY_PRODUCT_TYPE = 'validation.product.emptyProductType';
export const VALIDATION_PRODUCT_UNSUPPORTED_PRODUCT_TYPE = 'validation.product.unsupportedProductType';
export const VALIDATION_PRODUCT_IMMUTABLE_PRODUCT_TYPE = 'validation.product.immutableProductType';
export const VALIDATION_PRODUCT_EMPTY_ISIN_CODE = 'validation.product.emptyIsinCode';
export const VALIDATION_PRODUCT_NOT_EMPTY_ISIN_CODE = 'validation.product.notEmptyIsinCode';
export const VALIDATION_PRODUCT_INVALID_ISIN_CODE = 'validation.product.invalidIsinCode';
export const VALIDATION_PRODUCT_IMMUTABLE_ISIN_CODE = 'validation.product.immutableIsinCode';
export const VALIDATION_PRODUCT_EMPTY_DELIVERY_PERIOD = 'validation.product.emptyDeliveryPeriod';
export const VALIDATION_PRODUCT_NOT_EMPTY_DELIVERY_PERIOD = 'validation.product.notEmptyDeliveryPeriod';
export const VALIDATION_PRODUCT_IMMUTABLE_DELIVERY_PERIOD = 'validation.product.immutableDeliveryPeriod';
export const VALIDATION_PRODUCT_EMPTY_DELIVERY_TYPE = 'validation.product.emptyDeliveryType';
export const VALIDATION_PRODUCT_NOT_EMPTY_DELIVERY_TYPE = 'validation.product.notEmptyDeliveryType';
export const VALIDATION_PRODUCT_IMMUTABLE_DELIVERY_TYPE = 'validation.product.immutableDeliveryType';
export const VALIDATION_PRODUCT_EMPTY_QUANTITY_UNIT = 'validation.product.emptyQuantityUnit';
export const VALIDATION_PRODUCT_NOT_EMPTY_QUANTITY_UNIT = 'validation.product.notEmptyQuantityUnit';
export const VALIDATION_PRODUCT_IMMUTABLE_QUANTITY_UNIT = 'validation.product.immutableQuantityUnit';
export const VALIDATION_PRODUCT_EMPTY_SCOPE = 'validation.product.emptyScope';
export const VALIDATION_PRODUCT_NOT_EMPTY_SCOPE = 'validation.product.notEmptyScope';
export const VALIDATION_PRODUCT_IMMUTABLE_SCOPE = 'validation.product.immutableScope';
export const VALIDATION_PRODUCT_INVALID_NAME_LENGTH = 'validation.product.invalidNameLength';
export const VALIDATION_PRODUCT_EMPTY_PRODUCT_ID = 'validation.product.emptyProductId';
export const VALIDATION_PRODUCT_INVALID_PRODUCT_ID_LENGTH = 'validation.product.invalidProductIdLength';
export const VALIDATION_PRODUCT_INVALID_PRODUCT_ID = 'validation.product.invalidProductId';
export const VALIDATION_PRODUCT_IMMUTABLE_PRODUCT_ID = 'validation.product.immutableProductId';
export const VALIDATION_PRODUCT_INVALID_ICON_SYMBOL_LENGTH = 'validation.product.invalidIconSymbolLength';
export const VALIDATION_PRODUCT_IMMUTABLE_ICON_SYMBOL = 'validation.product.immutableIconSymbol';
export const VALIDATION_PRODUCT_INVALID_COLOR = 'validation.product.invalidIconColor';
export const VALIDATION_PRODUCT_IMMUTABLE_COLOR = 'validation.product.immutableIconColor';
export const VALIDATION_PRODUCT_ICON_WITHOUT_COLOR = 'validation.product.iconSymbolWithoutColor';
export const ERROR_PRODUCT_NOT_FOUND = 'product.notFound';
export const ERROR_PRODUCT_NO_DEACTIVATION_WHEN_AUCTIONS_EXIST = 'product.noDeactivationWhenAuctionsExist';
export const ERROR_PRODUCT_NO_DEACTIVATION_WHEN_AUCTION_LIMITS_EXIST = 'product.noDeactivationWhenAuctionLimitsExist';
export const ERROR_PRODUCT_NO_DEACTIVATION_WHEN_AUCTION_TEMPLATES_EXIST = 'product.noDeactivationWhenAuctionTemplatesExist';
export const ERROR_PRODUCT_INVALID_SORT_KEY = 'product.sort.invalidField';

export const createProductErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) { // NOSONAR javascript:S1479
        case VALIDATION_PRODUCT_ID_ALREADY_USED:
            result = i18n.t('products.error.product-id-already-used');
            break;
        case VALIDATION_PRODUCT_EMPTY_NAME:
            result = i18n.t('products.error.product-name-empty');
            break;
        case VALIDATION_PRODUCT_IMMUTABLE_NAME:
            result = i18n.t('products.error.product-name-immutable');
            break;
        case VALIDATION_PRODUCT_EMPTY_PRODUCT_TYPE:
            result = i18n.t('products.error.product-type-empty');
            break;
        case VALIDATION_PRODUCT_UNSUPPORTED_PRODUCT_TYPE:
            result = i18n.t('products.error.product-type-unsupported');
            break;
        case VALIDATION_PRODUCT_IMMUTABLE_PRODUCT_TYPE:
            result = i18n.t('products.error.product-type-immutable');
            break;
        case VALIDATION_PRODUCT_EMPTY_ISIN_CODE:
            result = i18n.t('products.error.product-isin-code-empty');
            break;
        case VALIDATION_PRODUCT_NOT_EMPTY_ISIN_CODE:
            result = i18n.t('products.error.product-isin-code-not-empty');
            break;
        case VALIDATION_PRODUCT_INVALID_ISIN_CODE:
            result = i18n.t('products.error.product-isin-code-invalid');
            break;
        case VALIDATION_PRODUCT_IMMUTABLE_ISIN_CODE:
            result = i18n.t('products.error.product-isin-code-immutable');
            break;
        case VALIDATION_PRODUCT_EMPTY_DELIVERY_PERIOD:
            result = i18n.t('products.error.product-delivery-period-empty');
            break;
        case VALIDATION_PRODUCT_NOT_EMPTY_DELIVERY_PERIOD:
            result = i18n.t('products.error.product-delivery-period-not-empty');
            break;
        case VALIDATION_PRODUCT_IMMUTABLE_DELIVERY_PERIOD:
            result = i18n.t('products.error.product-delivery-period-immutable');
            break;
        case VALIDATION_PRODUCT_EMPTY_DELIVERY_TYPE:
            result = i18n.t('products.error.product-delivery-type-empty');
            break;
        case VALIDATION_PRODUCT_NOT_EMPTY_DELIVERY_TYPE:
            result = i18n.t('products.error.product-delivery-type-not-empty');
            break;
        case VALIDATION_PRODUCT_IMMUTABLE_DELIVERY_TYPE:
            result = i18n.t('products.error.product-delivery-type-immutable');
            break;
        case VALIDATION_PRODUCT_EMPTY_QUANTITY_UNIT:
            result = i18n.t('products.error.product-quantity-unit-empty');
            break;
        case VALIDATION_PRODUCT_NOT_EMPTY_QUANTITY_UNIT:
            result = i18n.t('products.error.product-quantity-unit-not-empty');
            break;
        case VALIDATION_PRODUCT_IMMUTABLE_QUANTITY_UNIT:
            result = i18n.t('products.error.product-quantity-unit-immutable');
            break;
        case VALIDATION_PRODUCT_EMPTY_SCOPE:
            result = i18n.t('products.error.product-scope-empty');
            break;
        case VALIDATION_PRODUCT_NOT_EMPTY_SCOPE:
            result = i18n.t('products.error.product-scope-not-empty');
            break;
        case VALIDATION_PRODUCT_IMMUTABLE_SCOPE:
            result = i18n.t('products.error.product-scope-immutable');
            break;
        case VALIDATION_PRODUCT_INVALID_NAME_LENGTH:
            result = i18n.t('products.error.product-name-invalid-length', { max: params[0] });
            break;
        case VALIDATION_PRODUCT_EMPTY_PRODUCT_ID:
            result = i18n.t('products.error.product-id-empty');
            break;
        case VALIDATION_PRODUCT_INVALID_PRODUCT_ID_LENGTH:
            result = i18n.t('products.error.product-id-invalid-length', { maxLength: params[0] });
            break;
        case VALIDATION_PRODUCT_INVALID_PRODUCT_ID:
            result = i18n.t('products.error.product-id-invalid');
            break;
        case VALIDATION_PRODUCT_IMMUTABLE_PRODUCT_ID:
            result = i18n.t('products.error.product-id-immutable');
            break;
        case VALIDATION_PRODUCT_INVALID_ICON_SYMBOL_LENGTH:
            result = i18n.t('products.error.product-icon-symbol-invalid-length', { max: params[0] });
            break;
        case VALIDATION_PRODUCT_IMMUTABLE_ICON_SYMBOL:
            result = i18n.t('products.error.product-icon-symbol-immutable');
            break;
        case VALIDATION_PRODUCT_INVALID_COLOR:
            result = i18n.t('products.error.product-icon-color-invalid');
            break;
        case VALIDATION_PRODUCT_IMMUTABLE_COLOR:
            result = i18n.t('products.error.product-icon-color-immutable');
            break;
        case VALIDATION_PRODUCT_ICON_WITHOUT_COLOR:
            result = i18n.t('products.error.product-icon-symbol-without-color');
            break;
        case ERROR_PRODUCT_NO_DEACTIVATION_WHEN_AUCTIONS_EXIST:
            result = i18n.t('products.error.product-no-deactivation-when-auctions-exist');
            break;
        case ERROR_PRODUCT_NO_DEACTIVATION_WHEN_AUCTION_LIMITS_EXIST:
            result = i18n.t('products.error.product-no-deactivation-when-auction-limits-exist');
            break;
        case ERROR_PRODUCT_NO_DEACTIVATION_WHEN_AUCTION_TEMPLATES_EXIST:
            result = i18n.t('products.error.product-no-deactivation-when-auction-templates-exist');
            break;
        case ERROR_PRODUCT_INVALID_SORT_KEY:
            result = i18n.t('products.error.product-invalid-sort-key', { sortKey: params[0] });
            break;
        case ERROR_PRODUCT_NOT_FOUND:
            result = i18n.t('products.error.product-not-found');
            break;
        default:
            result = undefined;
    }
    return result;
};
